import { Address, DoctorAddress } from 'types';

export const getNameFromAddress = (address: Address | undefined) => {
  return address && address.countryIso === 'JP' ? address.translatedName : '';
};

export const getMailingNameFromAddress = (address: Address | undefined) => {
  return (
    address &&
    (address.countryIso === 'JP'
      ? address.translatedMailingName
      : address.mailingName)
  );
};

export const getSelectedBillingAddress = (
  tmSelectedBillAddressId: string | undefined,
  doctorAddress: DoctorAddress
) => {
  if (tmSelectedBillAddressId) {
    const selectedBillingAddres = doctorAddress.billingAddresses.find(
      address => address.salesforceId === tmSelectedBillAddressId
    );

    return selectedBillingAddres
      ? selectedBillingAddres
      : doctorAddress.defaultBillingAddress;
  }
  return doctorAddress.defaultBillingAddress;
};

export const getSelectedShippingAddress = (
  tmSelectedShipAddressId: string | undefined,
  doctorAddress: DoctorAddress
) => {
  if (tmSelectedShipAddressId) {
    const selectedShippingAddress = doctorAddress.shippingAddresses.find(
      address => address.salesforceId === tmSelectedShipAddressId
    );
    return selectedShippingAddress
      ? selectedShippingAddress
      : doctorAddress.defaultShippingAddress;
  }
  return doctorAddress.defaultShippingAddress;
};
